var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMusicNote = function SvgMusicNote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.81426V15.4013C17.5587 15.1461 17.0464 15 16.5 15C14.8431 15 13.5 16.3431 13.5 18C13.5 19.6568 14.8431 21 16.5 21C18.1569 21 19.5 19.6568 19.5 18V2.88851C19.5 2.05868 18.6779 1.47932 17.8964 1.75842L8.2964 5.187C7.81881 5.35756 7.5 5.80995 7.5 6.31709V16.9013C7.05874 16.6461 6.54643 16.5 6 16.5C4.34315 16.5 3 17.8431 3 19.5C3 21.1568 4.34315 22.5 6 22.5C7.65685 22.5 9 21.1568 9 19.5V11.0285L18 7.81426Z",
    fill: "#3983F2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMusicNote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/musicNote.ea92570d.svg";
export { ForwardRef as ReactComponent };